import { IProgressStats, ISkillCategoryStats, ITopSkillStats } from 'models/IStats';

export const calculateSkillCategoryStats = (progress: IProgressStats[]): ISkillCategoryStats[] => {
    const categoryMap = new Map<string, {
        skills: Set<string>;
        totalTasks: number;
        accuracySum: number;
        accuracyCount: number;
    }>();

    progress.forEach(item => {
        const category = item.skill_category;
        
        if (!categoryMap.has(category)) {
            categoryMap.set(category, {
                skills: new Set(),
                totalTasks: 0,
                accuracySum: 0,
                accuracyCount: 0
            });
        }

        const categoryData = categoryMap.get(category)!;
        categoryData.skills.add(item.skill);
        categoryData.totalTasks += item.tasks_solved;
        categoryData.accuracySum += item.accuracy_rate;
        categoryData.accuracyCount += 1;
    });

    return Array.from(categoryMap.entries()).map(([category, data]) => ({
        skill_category: category,
        skills_practiced: data.skills.size,
        tasks_solved: data.totalTasks,
        accuracy_rate: data.accuracyCount > 0 ? data.accuracySum / data.accuracyCount : 0
    }));
};

export const calculateTopSkills = (
    progress: IProgressStats[], 
    categoryFilter: string, 
    limit: number = 3
): ITopSkillStats[] => {
    const filteredProgress = progress.filter(item => 
        item.skill_category.toLowerCase().includes(categoryFilter.toLowerCase())
    );

    const skillMap = new Map<string, {
        students: Set<string>;
        totalTasks: number;
        accuracySum: number;
        accuracyCount: number;
    }>();

    filteredProgress.forEach(item => {
        if (!skillMap.has(item.skill)) {
            skillMap.set(item.skill, {
                students: new Set(),
                totalTasks: 0,
                accuracySum: 0,
                accuracyCount: 0
            });
        }

        const skillData = skillMap.get(item.skill)!;
        skillData.students.add(item.student_name);
        skillData.totalTasks += item.tasks_solved;
        skillData.accuracySum += item.accuracy_rate;
        skillData.accuracyCount += 1;
    });

    return Array.from(skillMap.entries())
        .map(([skill, data]) => ({
            skill,
            students_count: data.students.size,
            tasks_solved: data.totalTasks,
            accuracy_rate: data.accuracyCount > 0 ? data.accuracySum / data.accuracyCount : 0
        }))
        .sort((a, b) => b.students_count - a.students_count)
        .slice(0, limit);
};